import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import { AnimatedModal, AnimatedCloseButton } from '../shared/modal/styles';
import { recordStatisticsEvent } from '../../services/statistics-service';
import dt from '../../shared/theme';
import useFundsStateStore from './common/funds-state-hook';
import useGetFund from '../../services/funds/fund-service';
import Fund from '../fund/fund';

const SModal = styled(Modal)`
  outline: none;
  padding: 0 !important;
  display: none;
  opacity: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  & > article.horizontal {
    width: 100%;
    height:fit-content !important;
    margin-top: 40px;
    border-width: 1px;
    border-radius: 20px 20px 0px 0px;

    section {
      padding: 0 !important;
      text-align: left !important;
    }

    section:first-child, section:last-child {
      background-color: unset !important;
      color: unset !important;
      span:not(.callout-indicator) {
        height: unset !important;
      }
    }

    ${props => dt(props).theme.isMobileOrTablet && `
      margin: 40px auto 0;
    `};
  }

  & > article.horizontal.horizontal section {
    padding-top: 0px !important;
  }

  &.show {
    ${AnimatedModal};
  }

  button.close {
    float: right;
    background: transparent;
    border: none;
    outline: none;
    color: white;
    padding: 0;
    margin: -38px 25px 0 12px;
    font-size: 40px;
    opacity: 0;

    ${props => dt(props).theme.isMobileOrTablet && `
      margin: -38px 30px 0 12px;
      position: fixed;
      right: -15px;
    `};

    ${AnimatedCloseButton};
  }
`;

const Body = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;

  ${props => dt(props).theme.isMobileOrTablet && `
    border-top: 0;
  `};

  & > .frame {
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    border-radius: 15px 15px 0px 0px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }

    .top-rated > img {
      top: 64px;
    }
  }
`;

const Header = styled(Modal.Header)`
  height: 0px;
`;

export default function FundModal(props) {
  const { features } = props;
  const set = useFundsStateStore(state => state.set);
  const show = useFundsStateStore(state => state.showFundModal);
  const currentFund = useFundsStateStore(
    state => state.currentModalFund,
  );
  const [, getFund] = useGetFund();
  const [fundData, setFundData] = React.useState(null);
  let originalOnPopState;

  const handleHide = () => {
    setFundData(null);
    set(state => {
      state.showFundModal = false;
      state.currentModalFund = null;
    });
    window.onpopstate = originalOnPopState;

    if (window.history.state) {
      window.history.pushState({}, null, window.history.state.prevUrl);
    }
  };

  const handleShow = () => {
    originalOnPopState = window.onpopstate;

    window.onpopstate = e => {
      e && e.preventDefault();
      originalOnPopState && originalOnPopState();
      handleHide();
    };

    recordStatisticsEvent({
      event: 'fund_profile_embed_view',
      statisticable: 'fund',
      id: currentFund.id,
      clicked_url: `/fund/${currentFund.slug}`,
      page: window.history.state.prevUrl || window.location.pathname,
    });

    getFund(currentFund.id, features).then(({ data }) => {
      data && setFundData({ ...data, showInModal: true });
    });
  };

  return (
    <SModal
      show={show}
      centered="true"
      dialogAs="article"
      dialogClassName="horizontal"
      scrollable="true"
      onHide={handleHide}
      onShow={handleShow}
      className={show ? 'show' : 'hide'}
    >
      <Header closeButton />
      <Body id="fund-modal">
        <div className="frame">
          {!!fundData && <Fund {...fundData} newNavEnabled={false} />}
        </div>
      </Body>
    </SModal>
  );
}

/* eslint-disable-next-line react/require-default-props */
FundModal.propTypes = { features: PropTypes.string };
